// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__jU0MJ","item_detail__customize_button":"item_item_detail__customize_button__VQiA6"};